import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/Rebate/Get', params)
    },
    getList: params => {
        return API.GET('/api/Rebate/List', params)
    },
    add: params => {
        return API.POST('/api/Rebate/Add', params)
    },
    edit: params => {
        return API.POST('/api/Rebate/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/Rebate/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/Rebate/DeleteBatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/Rebate.js